// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Monitor_wrapper__23XmV"};